import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import clone from 'clone';

import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import LoadingCircle from 'components/LoadingCircle';
import Textbox from 'components/Textbox/index';
import Datepicker from "../../components/Datepicker";

const notificationTypes = [
    {
        label: 'Ad Campaign',
        value: 'ad_campaign'
    }, {
        label: 'Broadcast',
        value: 'broadcast'
    }, {
        label: 'News Item',
        value: 'newsfeed'
    }
];

export default class NotificationsForm extends React.Component {
    static propTypes = {
        ads: PropTypes.array,
        error: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        isSending: PropTypes.bool.isRequired,
        newsStories: PropTypes.array,
        notification: PropTypes.object.isRequired,
        notificationType: PropTypes.string,
        setNotification: PropTypes.func.isRequired,
        setNotificationType: PropTypes.func.isRequired
    };

    componentWillUnmount() {
        this.props.setNotification({});
    }

    setNotificationType = (type) => {
        console.log(type);
        this.props.setNotificationType(type);
        this.props.setNotification({});
    };

    handleCancel() {
        this.props.setNotificationType(null);
        this.props.setNotification({});
    };

    _handleChange(name, value) {
        let newNotificationObj = update(this.props.notification, {});
        newNotificationObj[name] = value;
        this.props.setNotification(newNotificationObj);
    }

    isValid  = () => {
        let { notification, notificationType } = this.props;

        if(!notificationType) {
            return true;
        }

        if(notification.sendAt && new Date(notification.sendAt).getTime() < new Date().getTime()) {
            return true;
        }

        switch(notificationType) {
            case notificationTypes[0].value:
                return !notification.body || !notification.adCampaignId;
            case notificationTypes[1].value:
                return !notification.body || !notification.title;
            case notificationTypes[2].value:
                return !notification.body || (!notification.url && !notification.textUrl);
            default:
                return true;
        }
    };

    render() {
        let { notificationType } = this.props;
        let ads = clone(this.props.ads).filter(ad => ad.status !== 'inactive');
        ads.forEach((ad) => {
            ad.label = `${ad.name}: ${ad.titleCopy}`;
            ad.value = ad.id;
        });
        return (
            <Form className="notifications-form">
                <FormRow>
                    <Dropdown
                        id="selNotificationType"
                        label="Notification Type"
                        name="notificationType"
                        onChange={(selectedValue) => { this.setNotificationType(selectedValue.value) }}
                        options={notificationTypes}
                        placeholder="Select notification type"
                        value={notificationType}
                    />
                </FormRow>
                {notificationType === 'broadcast' ? (
                    <FormRow>
                        <Textbox
                            id="txtNotificationTitle"
                            onChange={(event) => this._handleChange(event.target.name, event.target.value)}
                            label="Notification Title"
                            name="title"
                            type="text"
                            value={this.props.notification.title || ''}
                        />
                    </FormRow>
                ) : null}

                {notificationType ? (
                    <FormRow>
                        <Textbox
                            id="txtNotificationBody"
                            onChange={(event) => this._handleChange(event.target.name, event.target.value)}
                            label="Notification Body"
                            name="body"
                            type="textarea"
                            value={this.props.notification.body || ''}
                        />
                    </FormRow>
                ) : null}

                {notificationType === 'ad_campaign' ? (
                    <FormRow>
                        <Dropdown
                            id="selCampaign"
                            label="Ad Campaign"
                            name="adCampaignId"
                            onChange={(selectedValue) => this._handleChange('adCampaignId', selectedValue.id)}
                            options={ads}
                            placeholder="Select Ad Campaign"
                            value={this.props.notification.adCampaignId}
                        />
                    </FormRow>
                ) : null}

                {notificationType === 'newsfeed' ? (
                    <FormRow>
                        <Dropdown
                            id="selUrl"
                            label="News Story"
                            name="url"
                            onChange={(selectedValue) => {
                                this._handleChange('textUrl', null)
                                this._handleChange('url', selectedValue.postPageUrl);
                            }}
                            options={this.props.newsStories}
                            placeholder="Select News Story"
                            value={this.props.notification.url || ''}
                        />
                    </FormRow>
                ) : null}

                {notificationType === 'newsfeed' ? (
                    <FormRow>
                        <Textbox
                            id="txtUrl"
                            onChange={(event) => {
                                this._handleChange('url', null)
                                this._handleChange(event.target.name, event.target.value)
                            }}
                            label="or Enter Custom URL"
                            name="textUrl"
                            type="text"
                            value={this.props.notification.textUrl || ''}
                        />
                    </FormRow>
                ) : null}

                {notificationType ? (
                    <FormRow>
                        <Datepicker
                            dateFormat="M/dd/yy h:mma"
                            id="dateSendAt"
                            label="Schedule Notification"
                            minDate={new Date()}
                            name="sendAt"
                            onChange={(newDate) => this._handleChange('sendAt', newDate)}
                            placeholderText="Click to select time"
                            selected={this.props.notification.sendAt}
                            showTimeSelect
                            timeIntervals={10}
                        />
                    </FormRow>
                ) : null}

                {Object.keys(this.props.error).length > 0 ? (
                    <FormRow>
                        {this.props.error.friendlyMessage || this.props.error.message}
                    </FormRow>
                ) : null}

                <FormRow>
                    <Button
                        className="notifications__save-button"
                        disabled={this.isValid() || this.props.isSending === true}
                        onClick={this.props.handleSubmit.bind(this, notificationType)}
                        type="button"
                    >
                        {this.props.notification.id ? 'Save Changes' : (this.props.notification.sendAt ? 'Schedule Notification' : 'Send Notification')}

                        {this.props.isSending === true ? <LoadingCircle outerColor="#ffffff" /> : null}
                    </Button>

                    <Button
                        noStyles
                        onClick={this.handleCancel.bind(this)}
                    >
                        Cancel
                    </Button>
                </FormRow>
            </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/NotificationsPage/NotificationsForm.js